module.exports = __webpack_public_path__ + "assets/img/free_1.6642730c.png";